import {
  Space,
  Dropdown,
  message,
  Flex,
  Tooltip,
  Tag
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  EditOutlined,
  MenuOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import VendorTypeModal from "./component/VendorTypeModal";
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    code: undefined,
    name: undefined,
    order: undefined,
    status: undefined,
    desc: undefined,
  }

  const [tableHead, setTableHead] = useState(initTableHead);
  
  const [currentRecord, setCurrentRecord] = useState(null);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record, index) => (
        (commonFn.btnAuthorityFlag("Edit") || commonFn.btnAuthorityFlag("Delete")) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag("Edit") && {
                key: "edit",
                icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Edit</div>,
              },
              commonFn.btnAuthorityFlag("Delete") && {
                key: "delete",
                icon: <HistoryOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }} 
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>
        )) || null
    },
    {
      title: 'Type Code',
      dataIndex: "code",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'code')
    },
    {
      title: 'Type Name',
      dataIndex: "name",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'name')
    },
    {
      title: 'Sort Order',
      dataIndex: "order",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'order')
    },
    {
      title: 'Active',
      dataIndex: "status",
      titleType: 'Select',
      selectOptions: [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
      ],
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'status', 'Select'),
      render: (text) => {
        const isEnabled = text == 1;
        return (
          <Tag
            color={isEnabled ? "green" : "red"}
          >
            { isEnabled ? "Active" : "Inactive" }
          </Tag>
        )
      },
    },
    {
      title: 'Description',
      dataIndex: "desc",
      titleType: 'Input',
      onChange: e => tableFilterFn(e, 'desc'),
    },
    {
      title: 'New Requirement',
      dataIndex: "targetFields",
      titleType: '',
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      ...tableHead
    };
    const response = await http.get(api.vendorTypeList, { params });
    if(!response) return
    if(response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    setTableList(response.data);
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  // 新增修改
  const VendorTypeModalRef = useRef(null);
  
  const newFn = () => {
    VendorTypeModalRef.current.openModal({
      type: 'add',
      modalName: 'New Vendor Type',
    })
  }

  const customModalRef = useRef(null);

  const handleMenuClick = async (item, record) => {
    const { key } = item
    setCurrentRecord(record);
    if(['edit'].includes(key)){
      VendorTypeModalRef.current.openModal({
        oldState: record,
        type: 'edit',
        modalName: 'Edit Vendor Type',
      })
    }else if(['delete'].includes(key)) {
      customModalRef.current.openModalFn();
    }
  }

  const deleteFn = async () => {
    const response = await http.get(api.vendorTypeDelete, {
      params: {
        id: currentRecord.id
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn(1, 25, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  const initColunmsFn = () => {
    setTableList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn(1, 25, tableHead);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn()
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") && (
            <Space size="large">
                {commonFn.btnDocFn({ btnFn: newFn },{
                  imageStyle: { filter: "brightness(0) invert(1)" }
                })}
            </Space>
           )) || null}
        </div>
      </CustomTableExtend>

      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={false}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
      />

      <VendorTypeModal
        ref={VendorTypeModalRef}
        submitInitFn={submitInitFn}
      />

      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: "Vendor Type",
          onOkFn: deleteFn,
        }}
      />
    </div>
  );
});
export default MainTable;
